<script>

import { HOSTSERVER, EstadoRegistro } from '@/constants/global';

import DataTable from 'datatables.net-vue3'
import DataTablesLib from 'datatables.net'

import ButtonsHtml5 from 'datatables.net-buttons/js/buttons.html5'
import pdfmake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import 'datatables.net-responsive-bs5';
import 'datatables.net-buttons/js/buttons.colVis';
import JsZip from 'jszip';
import authService from '@/services/auth.service';
window.JSZip = JsZip;

DataTable.use(DataTablesLib);
DataTable.use(pdfmake);
DataTable.use(ButtonsHtml5);


export default {
  components: {
    DataTable
  },
  data() {
    return {
      tblAjax: {
        url: `${HOSTSERVER}/api/v1/usuarios`,
        headers: {
          'Authorization': `Bearer ${authService.getToken()}`,
        },
        dataSrc: 'data',
        data: (filters) => {
          const size = filters.length != -1 ? filters.length : 100000;
          let ordenable = filters.order[0] ?? {column: 0, dir:"desc"};
          let column = filters.columns[ordenable.column];
          return {
            page: ((size + filters.start) / size) - 1,
            filtro: filters.search.value ?? '',
            size: size,
            estado: EstadoRegistro.ACTIVO,
            order: column.data ?? 'id',
            dir: ordenable.dir
          }
        },
        dataFilter: (obj) => {
          //asignar los datos necesario
          let json = JSON.parse(obj);
          let recordsFiltered = (json && json.count) || 0;
          let recordsTotal = (json && json.count) || 0;
          let data = (json && json.data) || []

          let dataObj = { data, recordsFiltered, recordsTotal};

          return JSON.stringify(dataObj);
        }
      },
      tblValues: [],
      tblColumns: [
        { data: "id" },
        { data: "nombre" },
        { data: "usuario" },
        { data: "rol" },
        {
          data: null, "render": function (data) {
            return `
            <a href="/usuarios/edicion/${data.id}" class="btn btn-outline-primary">
              <i class="fas fa-edit"></i>
            </a>`
          }
        },
      ],
      tblOptions: {
        processing: true,
        serverSide: true,
        order: [[0, "desc"]],
        pageLength: 5,
        lengthMenu: [[5, 10, 20, -1], [5, 10, 20, 'Todos']],
        language: {
          url: "//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/Spanish.json"
        },
        dom: 'Blfrtip',
        buttons: [{
          extend: 'excelHtml5',
          title: 'Usuarios_smartclic',
          messageBottom: 'Esta informacion es de propiedad de SmartClic.pe',
          autoFilter: true,
          sheetName: 'Datos exportados',
          exportOptions: {
            columns: [1, 2, 3, 4]
          }
        },
        {
          extend: 'pdfHtml5',
          title: 'Usuarios_smartclic',
          messageBottom: 'Esta informacion es de propiedad de SmartClic.pe',
          exportOptions: {
            columns: [1, 2, 3, 4]
          }
        }],
        responsive: false,
        autoWidth: false,
        scrollX: true
      }
    }
  }
}

</script>
<template>
  <div class="space"></div>
  <div class="fondo">
    <div class="container recuadro bg-light mt-5 mb-5 p-5">
      <div class="mb-3">
        <RouterLink to="/usuarios/nuevo" class="btn btn-success"><i class="fas fa-plus-square"> Crear nuevo Usuario</i>
        </RouterLink>
      </div>

      <DataTable id="usuarios" class="table table-striped align-middle text-center mt-4" :ajax="tblAjax" :data="tblValues"
        :columns="tblColumns" :options="tblOptions">
        <thead>
          <tr class="bg-primary text-white">
            <th scope="col">ID</th>
            <th scope="col">Nombre</th>
            <th scope="col" class="col-sm-3">Usuario</th>
            <th scope="col">Rol</th>
            <th scope="col" class="col-sm-2">Acciones</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  </div>
</template>
<style>
@import 'datatables.net-bs5';
</style>
